module.exports = __webpack_public_path__ + "static/media/telegram.b91cc43e.svg";